import { HomeNewArrivals } from './HomeNewArrivals';
import { HomeZeroKm } from './HomeZeroKm';
import { HomeSeminovos } from './HomeSeminovos';
import { HomeServicesSection } from './HomeServicesSection';
import { AppDownloadSection } from './AppDownloadSection';
import { HomeCtaSections } from './HomeCtaSections';
import { resolveAppStoreUrl } from '@/lib/appStoreLinks';
import './services.css';
import './home.css';

interface HomeShowcaseProps {
  vehicles: any[];
  config: any;
  store: any;
}

/** Fluxo: novidades → zero km → seminovos → serviços → CTAs → app */
export function HomeShowcase({ vehicles, config, store }: HomeShowcaseProps) {
  const hasAppLinks =
    !!resolveAppStoreUrl(config.appStore) || !!config.googlePlay?.url?.trim();

  return (
    <>
      <HomeNewArrivals vehicles={vehicles} store={store} />

      <HomeZeroKm vehicles={vehicles} store={store} />

      <HomeSeminovos vehicles={vehicles} store={store} />

      <HomeServicesSection store={store} config={config} />

      <HomeCtaSections config={config} store={store} />

      {hasAppLinks && <AppDownloadSection config={config} />}
    </>
  );
}
